import { styled } from '@mui/material';

export const ModuleIconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '36px',
  height: '36px',
  flexShrink: 0,
  '& > .MuiSvgIcon-root': {
    color: theme.palette.text.primary,
    width: '24px',
    height: '24px',
  },
}));

export const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobileLayout' && prop !== 'hasSubordinates',
})<{ isMobileLayout?: boolean; hasSubordinates?: boolean }>(({ theme, isMobileLayout, hasSubordinates }) => ({
  width: '100%',
  height: '100%',
  minWidth: isMobileLayout ? 0 : '250px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: isMobileLayout ? (hasSubordinates ? 'flex-start' : 'center') : 'space-between',
  background: theme.palette.background.paper,
  borderRadius: '8px',
  border: `1px solid ${theme.palette.grey[200]}`,
  padding: isMobileLayout ? '8px 12px' : '8px 8px 0',
  ...(isMobileLayout && {
    '&:active': {
      borderColor: theme.palette.grey[400],
    },
  }),
  [theme.breakpoints.up('lg')]: {
    padding: isMobileLayout ? '8px 12px' : '8px 16px 0',
  },
}));

export const Header = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobileLayout' && prop !== 'hasSubordinates',
})<{ isMobileLayout?: boolean; hasSubordinates?: boolean }>(({ theme, isMobileLayout, hasSubordinates }) => ({
  display: 'flex',
  alignItems: 'center',
  height: isMobileLayout ? '36px' : '44px',
  minHeight: isMobileLayout ? '36px' : '44px',
  gap: '8px',
  paddingLeft: '4px',
  borderBottom: hasSubordinates ? `1px solid ${theme.palette.grey[100]}` : 'none',
  marginBottom: hasSubordinates ? '8px' : 0,
  paddingBottom: hasSubordinates ? '8px' : 0,
}));

export const TitleWrapper = styled('div')(() => ({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
}));

export const TitleContent = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  minWidth: 0,
  maxWidth: '100%',
}));

export const TitleText = styled('div')(() => ({
  minWidth: 0,
  overflow: 'hidden',
}));

export const moduleHeaderBadgeSx = { flexShrink: 0, padding: '3px 6px', fontSize: '12px' } as const;

export const Cards = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobileLayout',
})<{ isMobileLayout?: boolean }>(({ theme, isMobileLayout }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
  marginBottom: isMobileLayout ? 0 : '16px',
  [theme.breakpoints.down('md')]: {
    gap: '8px',
    marginBottom: isMobileLayout ? 0 : '8px',
  },
}));

export const MobileChildModules = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
  marginTop: '8px',
  [theme.breakpoints.down('md')]: {
    gap: '8px',
  },
}));

export const Footer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderTop: `1px solid ${theme.palette.grey[100]}`,
  '& > .MuiTypography-root': {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    fontSize: '13px',
  },
}));
